import * as Yup from "yup";
import { DEFAULT_COUNTRY_CODE } from "us.common/constants"

interface AddPostal extends Yup.MixedSchema {
  PostalCode: string;
  SelectedMunicipalityName: string;
  PostalPlace: string;
  SelectedMunicipalityCode: string;
  CityAreaNo: string;
}

export const validationSchema = Yup.object<AddPostal>().shape({
  countryCode: Yup.string()
    .required(
      "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALUE_INTO_THE_FIELD"
    )
    .typeError(
      "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD"
    ),
  postalCode: Yup.string()
    .when("countryCode", {
      is: DEFAULT_COUNTRY_CODE,
      then: Yup.string().matches(/^\d+$/, "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD"),
      otherwise: Yup.string(),
    })
    .required(
      "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALUE_INTO_THE_FIELD"
    )
    .typeError(
      "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD"
    ),
  postalPlace: Yup.string()
    .required(
      "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALUE_INTO_THE_FIELD"
    )
    .test(
      "postalPlaceDigit",
      "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD",
      (val: any) => {
        let value = typeof val == "undefined" ? "" : val;
        return !/^\d+$/.test(value);
      }
    ),
  municipalityName: Yup.string()
    .required(
      "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALUE_INTO_THE_FIELD"
    ),
});
